import { makeTranslationHelpers } from '@/hooks/useTranslation';

const { useTranslation: useOwnershipTranslations, Translation } =
  makeTranslationHelpers('page.companyReport.ownership');

export { useOwnershipTranslations, Translation as OwnershipTranslation };
